export const languageOptions = [
  { label: '🇩🇪', value: 'de' },
  { label: '🇺🇸', value: 'en' },
];
